import styled from "styled-components";

import { colors } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

/* Shared header for OffCanvas-style trays. The notch zone above this
 * header is painted by Layout's TopInsetSpacer (the parent tray's
 * padding-top: env(...) pushes the header below it on standalone). */
const OffCanvasTrayHeader = styled.div`
  padding: 30px 20px;
  position: relative;
  flex-shrink: 0;
  text-align: center;
  background-color: ${colors.white};
  ${breakpoints.smDown} {
    padding: 20px 15px;
  }
`;

export default OffCanvasTrayHeader;
